import { SetStateAction, Dispatch } from "react";
import { TransformedEvent, OriginalEvent, readCSV } from "./ParsingUtil";

export async function fetchData({
  setAppoitments,
  setFilteredAppointmnets,
}: {
  setAppoitments: Dispatch<SetStateAction<TransformedEvent[]>>;
  setFilteredAppointmnets: Dispatch<SetStateAction<TransformedEvent[]>>;
}) {
  try {
    const result = await readCSV();
    const lexwareEvents: OriginalEvent[] = result.lexware;
    //const ideskEvents: OriginalEvent[] = result.idesk;
    const transformedEvents: TransformedEvent[] = lexwareEvents.map((event) => {
      const eventDates = event.Datum.split("-");
      if (eventDates.length > 1) {
        const [startDay, startMonth, startYear] = eventDates[0]
          .split(".")
          .map(Number);
        const [endDay, endMonth, endYear] = eventDates[1]
          .split(".")
          .map(Number);
        return {
          title: event.Kurztitel,
          start: new Date(startYear, startMonth - 1, startDay),
          end: new Date(endYear, endMonth - 1, endDay),
          allDay: true,
          resource: {
            longTitle: event.Titel,
            description: event.Beschreibung,
            link: event.LexwareLink.split(">"),
            topic: event.RubrikLexware,
          },
        };
      } else {
        const [day, month, year] = event.Datum.split(".").map(Number);
        return {
          title: event.Kurztitel,
          start: new Date(year, month - 1, day),
          end: new Date(year, month - 1, day),
          allDay: true,
          resource: {
            longTitle: event.Titel,
            description: event.Beschreibung,
            link: event.LexwareLink.split(">"),
            topic: event.RubrikLexware,
          },
        };
      }
    });
    setAppoitments(transformedEvents);
    setFilteredAppointmnets(transformedEvents);
  } catch (error) {
    console.error("An error occurred:", error);
  }
}
